import { createFileRoute } from "@tanstack/react-router";
import { PlatsDetailView } from "@/lib/features/PlatsDetailView";
export const Route = createFileRoute("/_app/plats/$id")({
  component: PlatsDetailView
});